import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  contentContainer: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  header: {
    marginBottom: 30,
    marginTop: 30,
    textAlign: 'center'
  },
  title: {
    position: 'relative'
  },
  separatorContainer: {
    marginTop: 40,
    marginBottom: 30
  },
  separator: {
    marginTop: 32
  },
  policiesTitleContainer: {
    position: 'relative',
    top: -10,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  policiesTitle: {
    backgroundColor: theme.palette.background.default,
    paddingLeft: 8,
    paddingRight: 8,
    width: 'fit-content'
  },

  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  button: {
    marginTop: 40,
    marginBottom: 20,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: 35
    }
  },
  noPilocies: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20
  },
  tableHeaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTop: '1px solid gray',
    paddingTop: 30,
    paddingBottom: 10,
    marginTop: 20
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
export default useStyles
